import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import clsx from 'classnames';

import { useStyles } from '../../hooks';
import styles from './styles';

const BoxRaised = ({
  width = '55%',
  marginBottom = '-5%',
  maxWidth= {undefined},
  className,
  children,
  root2 = false,
  root3 = false
}) => {
  const classes = useStyles(styles);

  return (
    <Box
      width={width}
      mb={marginBottom}
      maxWidth={maxWidth}
      className={clsx(root2 ? classes.root2 : root3 ? classes.root3 : classes.root, className)}
    >
      { children }
    </Box>
  );
}

BoxRaised.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  marginBottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default BoxRaised;
